module.exports = __webpack_public_path__ + "img/40_38_036_310.58db1ac3.jpg";